export default "__VITE_ASSET__CF7Z6ZlM__"